import React, { useEffect, useRef, useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

// Compact copy control — copies the RAW value, never rendered/formatted text.
export function CopyValueButton({ value, label, className }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);
  const unavailable = value === null || value === undefined || value === "";
  useEffect(() => () => { if (timer.current) window.clearTimeout(timer.current); }, []);
  const copy = async (e) => {
    if (e) e.stopPropagation();
    if (unavailable) return;
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      if (timer.current) window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => { setCopied(false); timer.current = null; }, 1500);
    } catch (err) {
      setCopied(false);
      toast.error(`Couldn't copy ${label}`);
    }
  };
  return (
    <button type="button" onClick={copy} disabled={unavailable}
      aria-label={copied ? `${label} copied` : `Copy ${label}`}
      title={unavailable ? "Unavailable" : copied ? "Copied" : `Copy ${label}`}
      data-testid={`copy-${String(label).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
      className={cn("inline-grid place-items-center h-6 w-6 shrink-0 rounded-md text-ink-muted transition-colors hover:bg-surface-2 hover:text-ink-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-signal-blue disabled:opacity-40 disabled:cursor-default", className)}>
      {copied ? <Check className="h-3.5 w-3.5 text-emerald-600" /> : <Copy className="h-3.5 w-3.5" />}
    </button>
  );
}

export default CopyValueButton;
